"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePurchaseAmount = exports.validatePurchasePurpose = void 0;
const validatePurchasePurpose = desc => {
    if (!desc) {
        return true;
    }
    const restrictedStrings = ['"', "'", '/', '<', '>', '&'];
    const isInvalid = restrictedStrings.find(s => desc.includes(s));
    return !isInvalid;
};
exports.validatePurchasePurpose = validatePurchasePurpose;
const countDecimals = function (num) {
    if (Math.floor(num.valueOf()) === num.valueOf()) {
        return 0;
    }
    return num.toString().split('.')?.[1]?.length || 0;
};
const validatePurchaseAmount = amount => {
    if (!amount) {
        return true;
    }
    return !Number.isNaN(amount) && Number(amount) > 0 && countDecimals(amount) <= 2;
};
exports.validatePurchaseAmount = validatePurchaseAmount;
